export default __webpack_public_path__ + "static/media/1150.254ccafb.png";